import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { ObservationPointVM, ObservationPointVMEdit, SchematicDataVM, SchematicDataVMEdit, UpdateObsPointVM } from '../setup-implement/setup-implement.model';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'schemantic-op-popup-edit',
  templateUrl: './schemantic-op-popup-edit.component.html',
  styleUrls: ['./schemantic-op-popup-edit.component.scss']
})
export class SchemanticOpPopupEditComponent implements OnInit {

  positionX: string = "200";
  positionY: string = "50";
  schematic: SchematicDataVMEdit = new SchematicDataVMEdit();
  title: string = "Schematic";

  //@Input() mouseoverMPId: number = 0;
  mouseoverOPId: number = 0;
  currentStep: number = 0;

  eventX: number
  eventY: number
  //  window.
  showSchematic: boolean = false;
  schematicPositionX: number;
  schematicPositionY: number;

  // Mouse events for draggable schematic window.
  isMouseDown: boolean = false;
  prevMouseX: number;
  prevMouseY: number;
  selectedSchematic: SchematicDataVMEdit;

  showAddObservation: boolean = false
  mouseclick: boolean = false

  TempObservationPoints: ObservationPointVMEdit[]
  obsDetails: ObservationPointVMEdit[]
  //crack data
  TypeID: number
  startXY: string;
  endXY: string;
  isStartEdit: boolean = false;
  isEndEdit: boolean = false;
  EndeventX: number
  EndeventY: number
  Compname: string;

  FilteredschematicList: SchematicDataVM[] = [];
  FilteredschematicList_: SchematicDataVM;
  FilteredschematicList_2: SchematicDataVM;
  componentId: any;
  componentList: any;
  ImplementId: number;
  ObservationPointId: number;
  newComponentId: number;
  isUpdate: boolean = false;

  constructor(private _sanitizer: DomSanitizer,
    public openObservationPointModel: MatDialog,
    public dialogRef: MatDialogRef<SchemanticOpPopupEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private _implementService: SetupImplementService,
    private _notify: NotificationsService,
  ) { }

  ngOnInit() {
    this.schematic = this.data.schematic
    this.mouseoverOPId = this.data.mouseoverOPId
    this.currentStep = this.data.currentStep
    this.FilteredschematicList = this.data.FilteredschematicList
    this.ImplementId = this.data.ImplementId
    this.TempObservationPoints = this.schematic.ObservationPoints;
    this.componentId = this.data.ComponentId;
    this.ObservationPointId = this.data.ObservationId;
    console.log(this.ObservationPointId);
    console.log("this.componentId", this.componentId);
    if (this.schematic.ImageName != null) {
      this.title = this.schematic.ImageName;
    }

    this.Compname = this.schematic.ObservationPoints[0].Name
    this.eventX = this.schematic.ObservationPoints[0].PositionX
    this.eventY = this.schematic.ObservationPoints[0].PositionY
    this.startXY = this.schematic.ObservationPoints[0].PositionX.toString() + " ," + this.schematic.ObservationPoints[0].PositionY.toString();
    this.endXY = this.schematic.ObservationPoints[0].PositionXEnd != null ? this.schematic.ObservationPoints[0].PositionXEnd.toString() + " ," + this.schematic.ObservationPoints[0].PositionYEnd.toString() : null;
    this.EndeventX = this.schematic.ObservationPoints[0].PositionXEnd
    this.EndeventY = this.schematic.ObservationPoints[0].PositionYEnd

    console.log(" this.schematic____", this.schematic)
    console.log(" this.FilteredschematicList_____", this.FilteredschematicList)
    // Loop through each observation point in this.FilteredschematicList


    this.FilteredschematicList[0].ObservationPoints.forEach(filterPoint => {
      // Check if the ID of the current filterPoint exists in this.schematic.ObservationPoints
      const matchingPoint = this.schematic.ObservationPoints.find(schematicPoint => schematicPoint.Id === filterPoint.Id);

      // If a matching point is found, set selected to true
      if (matchingPoint) {
        filterPoint.SelectedObs = true;
      } else {

        filterPoint.SelectedObs = false;
      }
    });

    this.FilteredschematicList_ = this.FilteredschematicList[0];
    this.FilteredschematicList_2 = this.FilteredschematicList[0];
    this.getAllComponents();
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  setWindowPosition(posX: string, posY: string) {
    return this._sanitizer.bypassSecurityTrustStyle('Left: ' + posX + 'px;' + 'Top: ' + posY + 'px;' + 'Position: absolute; z-index: 10;');
  }


  getPosition(posX: string, posY: string) {
    var iPX = (parseFloat(posX));
    var iPY = (parseFloat(posY));
    return {
      position: 'absolute',   // Add this if necessary for positioning
      left: `${iPX}px`,
      top: `${iPY}px`
    };
    //return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;z-inde:1');
  }  

  // getPosition(x: number, y: number): { [key: string]: string } {
  //   var iPX = (x / 640.0) * 340;
  //   var iPY = (y / 520.0) * 270;
  //   return {
  //     position: 'absolute',   // Add this if necessary for positioning
  //     left: `${iPX}px`,
  //     top: `${iPY}px`
  //   };
  // }
  ClearCurrentStartXY() {
    this.startXY = null;
    this.isStartEdit = true;
    this.isEndEdit = false;

  }

  ClearCurrentEndXY() {
    this.endXY = null;
    this.isStartEdit = false;
    this.isEndEdit = true;
  }

  ConfirmStartXY() {
    this.startXY = this.eventX.toString() + " ," + this.eventY.toString();
    console.log("data", this.eventX + " ," + this.eventY)

    this.isStartEdit = false;

    var colour = "#EC0A0A";

    this.FilteredschematicList_.ObservationPoints.map(x => {
      if (x.SelectedObs == true) {
        x.PositionX = this.eventX
        x.PositionY = this.eventY

      }
    })
  }
  ConfirmEndXY() {
    console.log("data wnd ", this.EndeventX + " ," + this.EndeventY)
    this.endXY = this.EndeventX != null ? this.EndeventX.toString() + " ," + this.EndeventY.toString() : null;


    this.FilteredschematicList_.ObservationPoints.map(x => {
      if (x.SelectedObs == true) {
        x.EndPositionX = this.EndeventX
        x.EndPositionY = this.EndeventY

      }
    })
    this.isEndEdit = false;
  }
  isNew: boolean = false

  openObservationPointModal(event) {


    this.isNew == true

    console.log("open obsercation point modal", event)
    console.log("openthis.currentStep", this.currentStep)
    //this.RemoveTempOP()
    if ((this.schematic.Id > 0) && (this.currentStep == 2)) {
      if (this.schematic.ObservationPoints[0].ObservationType != "Crack") {
        this.showAddObservation = true;
        this.AddTempOP(event);
        this.eventX = event.offsetX - 10;
        this.eventY = event.offsetY - 10;
        this.mouseclick = true

      } else {

        this.showAddObservation = true;
        this.AddTempOP_Crack(event);
        //this.eventX = event.offsetX - 10;
        // this.eventY = event.offsetY - 10;
        this.mouseclick = true
      }
    }
  }


  onCloseClick(): void {
    this.dialogRef.close(this.isUpdate);
  }

  updatePosition(cp: ObservationPointVM, propName: string) {
    let havedata = this.schematic.ObservationPoints.find(x => x.Id == -1)
    console.log("havedata", havedata, cp)

    this.eventX = cp.PositionX
    this.eventY = cp.PositionY
    this.EndeventX = cp.EndPositionX
    this.EndeventY = cp.EndPositionY

    if (havedata) {
      this.schematic.ObservationPoints.map(x => {
        if (x.Id == -1) {
          x.PositionX = cp.PositionX
          x.PositionY = cp.PositionY
          x.PositionXEnd = cp.EndPositionX
          x.PositionYEnd = cp.EndPositionY
        }
      })


      this.FilteredschematicList_.ObservationPoints.map(x => {
        if (x.Id == -1) {
          x.PositionX = cp.PositionX
          x.PositionY = cp.PositionY
          x.EndPositionX = cp.EndPositionX
          x.EndPositionY = cp.EndPositionY
        }
      })

    } else {
      this.TempObservationPoints = this.schematic.ObservationPoints;
      let arr_ = [];
      let arr_2 = [];
      var tempOP: ObservationPointVMEdit = new ObservationPointVMEdit();
      tempOP.PositionX = cp.PositionX
      tempOP.PositionY = cp.PositionY;
      tempOP.PositionXEnd = cp.EndPositionX;
      tempOP.PositionYEnd = cp.EndPositionY;

      tempOP.Id = -1;
      // tempOP.observationPointTypeId = this.TypeID;
      tempOP.IsNew = true;


      var tempOP_: ObservationPointVM = new ObservationPointVM();
      tempOP_.PositionX = cp.PositionX
      tempOP_.PositionY = cp.PositionY;
      tempOP_.EndPositionX = cp.EndPositionX;
      tempOP_.EndPositionY = cp.EndPositionY;

      tempOP_.Id = -1;
      // tempOP.observationPointTypeId = this.TypeID;
      tempOP_.IsNew = true;


      if (this.TempObservationPoints != null && this.TempObservationPoints.length > 0) {
        this.TempObservationPoints.push(tempOP)
      } else {
        this.TempObservationPoints = arr_;
      }
      this.schematic.ObservationPoints = this.TempObservationPoints;

      this.FilteredschematicList_.ObservationPoints.push(tempOP_);


      console.log(" this.FilteredschematicList_.ObservationPoints", this.FilteredschematicList_)

    }
  }







  getEval(wornPct: number, inspectDate: string) {
    if (this.isNew == true) {
      return 'magenta'

    }


    else {
      //   if ((wornPct == 0) && (inspectDate == "Never")) {
      //     return 'gray';
      // } else if (wornPct <= 30) {
      //     return 'green';
      // } else if ((wornPct > 30) && (wornPct <= 60)) {
      //     return 'yellow';
      // } else if ((wornPct > 60) && (wornPct <= 80)) {
      //     return 'orange';
      // } else if (wornPct > 80) {
      //     return 'red';
      // }
      // else {
      return 'gray';
      // }
    }

  }

  onMouseOverMP(id) {
    // this.mouseoverMP.emit(id);
  }

  onMouseOutMP(id) {
    // this.mouseoverMP.emit(0);
  }

  onMouseOverOP(id) {
    // this.mouseoverOP.emit(id);
  }

  onMouseOutOP() {
    //  this.mouseoverOP.emit(0);
  }



  AddTempOP_Crack(event) {
    this.TempObservationPoints = this.schematic.ObservationPoints;
    let arr_ = [];

    if (this.TempObservationPoints != null) {
      if (this.TempObservationPoints.find(x => x.Id == -1)) {
        let val = this.TempObservationPoints.find(x => x.Id == -1);
        if (this.isStartEdit) {
          this.eventX = event.offsetX - 10;
          this.eventY = event.offsetY - 10;

          val.PositionX = event.offsetX - 10;
          val.PositionY = event.offsetY - 10;
        } else {
          val.PositionXEnd = event.offsetX - 10;
          val.PositionYEnd = event.offsetY - 10;

          this.EndeventX = event.offsetX - 10;
          this.EndeventY = event.offsetY - 10;
        }
      } else {
        var tempOP: ObservationPointVMEdit = new ObservationPointVMEdit();
        if (this.isStartEdit) {
          tempOP.PositionX = event.offsetX - 10;
          tempOP.PositionY = event.offsetY - 10;
          this.eventX = event.offsetX - 10;
          this.eventY = event.offsetY - 10;

        } else {
          tempOP.PositionXEnd = event.offsetX - 10;
          tempOP.PositionYEnd = event.offsetY - 10;
          this.EndeventX = event.offsetX - 10;
          this.EndeventY = event.offsetY - 10;

        }
        tempOP.isCrackFixed = false;
        tempOP.Id = -1;
        //  tempOP.observationPointTypeId = this.TypeID;
        tempOP.IsNew = true;
        arr_.push(tempOP);

        if (this.TempObservationPoints != null && this.TempObservationPoints.length > 0) {
          this.TempObservationPoints.push(tempOP)
        } else {
          this.TempObservationPoints = arr_;
        }
        this.obsDetails = this.TempObservationPoints;
      }
    }

  }



  AddTempOP(event) {
    this.TempObservationPoints = this.schematic.ObservationPoints;
    let arr_ = [];
    let arr_2 = [];

    this.RemoveTempOP();
    var tempOP: ObservationPointVMEdit = new ObservationPointVMEdit();
    tempOP.PositionX = event.offsetX - 10;
    tempOP.PositionY = event.offsetY - 10;
    tempOP.Id = -1;
    // tempOP.observationPointTypeId = this.TypeID;
    tempOP.IsNew = true;


    var tempOP_: ObservationPointVM = new ObservationPointVM();
    tempOP_.PositionX = event.offsetX - 10;
    tempOP_.PositionY = event.offsetY - 10;
    tempOP_.Id = -1;
    // tempOP.observationPointTypeId = this.TypeID;
    tempOP_.IsNew = true;


    if (this.TempObservationPoints != null && this.TempObservationPoints.length > 0) {
      this.TempObservationPoints.push(tempOP)
    } else {
      this.TempObservationPoints = arr_;
    }
    this.schematic.ObservationPoints = this.TempObservationPoints;

    this.FilteredschematicList_.ObservationPoints.push(tempOP_);


    console.log(" this.FilteredschematicList_.ObservationPoints", this.FilteredschematicList_)

    this.FilteredschematicList_.ObservationPoints.map(x => {
      if (x.SelectedObs == true) {
        x.PositionX = event.offsetX - 10
        x.PositionY = event.offsetY - 10
      }
    })

  }

  RemoveTempOP() {
    if (this.TempObservationPoints != null) {
      if (this.TempObservationPoints.find(x => x.Id == -1)) {
        this.TempObservationPoints.splice(this.TempObservationPoints.findIndex(x => x.IsNew == true), 1);
      }
    }
    this.TempObservationPoints = this.schematic.ObservationPoints;;
    if (this.FilteredschematicList_.ObservationPoints.find(x => x.Id == -1)) {
      this.FilteredschematicList_.ObservationPoints.splice(this.FilteredschematicList_.ObservationPoints.findIndex(x => x.IsNew == true), 1);
    }

    this.FilteredschematicList_2.ObservationPoints = this.FilteredschematicList_2.ObservationPoints.filter(point => point.Id !== -1);

  }

  // editObservation()

  // {


  //       // if (this.isFECRCrack == true) {
  //       //   this.TypeID = 6
  //       // } else if (this.isFECRNormal) {
  //       //   this.TypeID = 5
  //       // }


  //       this.eventX= this.schematic.ObservationPoints.find(x=>x.Id==-1).PositionX;
  //       this.eventY= this.schematic.ObservationPoints.find(x=>x.Id==-1).PositionY;
  //       this.EndeventX= this.schematic.ObservationPoints.find(x=>x.Id==-1).PositionXEnd;
  //       this.EndeventY= this.schematic.ObservationPoints.find(x=>x.Id==-1).PositionYEnd;

  //       var saveParams: ObservationPointVMEdit = new ObservationPointVMEdit();
  //       saveParams.Name =this.Compname;      
  //       console.log("this.schematic.ObservationPoints",this.schematic.ObservationPoints[0].Id)
  //       saveParams.Id=  this.schematic.ObservationPoints[0].Id       
  //       saveParams.PositionX = this.eventX
  //       saveParams.PositionY = this.eventY                  
  //       saveParams.PositionXEnd = (this.schematic.ObservationPoints[0].ObservationType=="Crack")?this.EndeventX:null;
  //       saveParams.PositionYEnd=(this.schematic.ObservationPoints[0].ObservationType=="Crack")?this.EndeventY:null;



  //       this._implementService.UpdateObservationPoints(saveParams).subscribe(res => {

  //         if (res == true) {
  //          // this.OPId = res

  //          this._notify.success('Observation saved successfully!');

  //           this.dialogRef.close(true)
  //         }
  //         else {
  //           this._notify.error('Save Unsuccessful');

  //         }

  //       })



  // }
  onComponentChange(event: any) {
    console.log('Event:', event.value); 
    this.newComponentId = event.value;
    this.editComponentForObservation();
  }
  editComponentForObservation() {
    const updateData = { ObservationPointId: this.ObservationPointId, ComponentId: this.newComponentId };
    console.log(updateData);
    this._implementService.UpdateComponentsForObservationPoints(updateData).subscribe(res=>{
      if(res==true){
        this._notify.success('Component saved successfully!');
      }else{
        this._notify.error('Save Unsuccessful');
      }
    });
  }
  
  editObservation() {
    // Find the observation point with Id == -1
    const observationPoint = this.schematic.ObservationPoints.find(x => x.Id == -1);

    // Initialize saveParams
    const saveParams: ObservationPointVMEdit = new ObservationPointVMEdit();
    saveParams.Name = this.Compname;

    // If observation point with Id == -1 is found, update all properties
    if (observationPoint) {
      this.eventX = observationPoint.PositionX;
      this.eventY = observationPoint.PositionY;
      this.EndeventX = observationPoint.PositionXEnd;
      this.EndeventY = observationPoint.PositionYEnd; 
      saveParams.Id= this.schematic.ObservationPoints[0].Id;
     // saveParams.Id = observationPoint.Id;
      saveParams.PositionX = this.eventX;
      saveParams.PositionY = this.eventY;
      // saveParams.PositionXEnd = (observationPoint.ObservationType == "Crack") ? this.EndeventX : null;
      saveParams.PositionXEnd = (this.schematic.ObservationPoints[0].ObservationType == "Crack") ? this.EndeventX : null;
      saveParams.PositionYEnd = (this.schematic.ObservationPoints[0].ObservationType == "Crack") ? this.EndeventY : null;
      // saveParams.PositionYEnd = (observationPoint.ObservationType == "Crack") ? this.EndeventY : null;
    } else {
      // If not found, update only the name
      console.log("Observation point with Id -1 not found, updating name only");
      saveParams.Id = this.schematic.ObservationPoints[0].Id;
      saveParams.PositionX = this.schematic.ObservationPoints[0].PositionX;
      saveParams.PositionY = this.schematic.ObservationPoints[0].PositionY;
      saveParams.PositionXEnd = this.schematic.ObservationPoints[0].PositionXEnd;
      saveParams.PositionYEnd = this.schematic.ObservationPoints[0].PositionYEnd;

    }

    // Update observation points using the service
    this._implementService.UpdateObservationPoints(saveParams).subscribe(res => {
      if (res == true) {
        this._notify.success('Observation saved successfully!');
        this.dialogRef.close(true);
      } else {
        this._notify.error('Save Unsuccessful');
      }
    });
  }
  

  getLine(posX: string, posY: string, EndposX: string, EndposY: string, isCrackFixed: boolean) {
    // bottom right
    // var x1 = (parseFloat(posX) / 640.0) * 340
    // var y1 = (parseFloat(posY) / 520.0) * 270;
    // // top right
    // var x2 = (parseFloat(EndposX) / 640.0) * 340
    // var y2 = (parseFloat(EndposY) / 520.0) * 270;

    var x1 = (parseFloat(posX));
    var y1 = (parseFloat(posY));
    // top right
    var x2 = (parseFloat(EndposX));
    var y2 = (parseFloat(EndposY)) ;



    // distance
    var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
    // center
    var cx = (((x1 + x2) / 2) - (length / 2)) + 7;
    var cy = ((y1 + y2) / 2) - (4 / 2);
    // angle
    var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
    // make hr
    var colour = isCrackFixed == false ? "#EC0A0A" : "#0000FF";
    return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 +
      'px; background-color:' + colour + '; line-height:1px; position:absolute; left:' + cx +
      'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');

  }
  // getLine(posX: string, posY: string, EndposX: string, EndposY: string,isCrackFixed:boolean) {
  //   // bottom right
  //   var x1 = (parseFloat(posX));
  //   var y1 = (parseFloat(posY));
  //   // top right
  //   var x2 = (parseFloat(EndposX));
  //   var y2 = (parseFloat(EndposY));
  //   // distance
  //   var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
  //   // center
  //   var cx = (((x1 + x2) / 2) - (length / 2)) + 7;
  //   var cy = ((y1 + y2) / 2) - (4 / 2);
  //   // angle
  //   var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
  //   // make hr

  //   var colour =isCrackFixed==false?"#EC0A0A":"#4472C4";
  //   return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 + 
  //   'px; background-color:' +colour + '; line-height:1px; position:absolute; left:' + cx + 
  //   'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');

  //    }

  //to get all the components TT-9461
  getAllComponents(){
    this._implementService.GetAllComponents(this.ImplementId).subscribe(res=>{
      this.componentList=res;
      console.log("this.componentList",this.componentList)
    })
  }

  updatedProperty(cp: ObservationPointVM, propertyName: string) {
    console.log(`Changing ${propertyName} for Observation Point:`, cp);
    if (propertyName === 'PositionX') {
      console.log('PositionX changed to:', cp.PositionX);
    }
    if (propertyName === 'PositionY') {
      console.log('PositionY changed to:', cp.PositionY);
    }
    if (propertyName === 'EndPositionX') {
      console.log('EndPositionX changed to:', cp.EndPositionX);
    }
    if (propertyName === 'EndPositionY') {
      console.log('EndPositionY changed to:', cp.EndPositionY);
    }
    if (propertyName === 'CompName') {
      console.log('Name changed to:', this.Compname);
    }
    this.saveUpdatedValue(cp, propertyName);
  }

  saveUpdatedValue(cp: ObservationPointVM, propertyName: string){
    var updateData: UpdateObsPointVM;
    var query: string;
    if(propertyName === 'CompName'){
      query = `Name='${this.Compname}'`;
      updateData = {SetValue: query, ObservationPointId: this.ObservationPointId };
    }
    else {
      query = `${propertyName}=${cp[propertyName]}`;
      updateData = {SetValue: query, ObservationPointId: cp.Id };
    }
    
    this._implementService.UpdateValuesForObservationPoints(updateData).subscribe(res =>{
      if(res == true){
        this.isUpdate = true;
        this._notify.success('Observation saved successfully!');
      }
      else{
        this._notify.error('Save Unsuccessful');
    }
   });
  }
}
